import { ShowWhenTrue } from "@/components/conditionals"
import { BodyCaption } from "@/domains/design/components/body-caption"
import { cn } from "@/domains/library"
import { TokenStore } from "@/domains/tokens"

import { TokenIcon } from "../token-icon"

export const TokenDialogQuickSelect: React.FC<{
  tokens: Array<TokenStore>
  onTokenSelect: (token: TokenStore) => void
  onClose?: () => void
}> = ({ tokens, onTokenSelect, onClose }) => {
  if (tokens.length === 0) {
    return null
  }

  const handleTokenSelect = (token: TokenStore) => {
    onTokenSelect(token)
    onClose?.()
  }

  return (
    <>
      <ShowWhenTrue when={tokens.length > 0}>
        <div>
          <BodyCaption className="mb-1 ml-1 text-t200">Trending</BodyCaption>
          <div className="flex flex-row flex-wrap gap-2">
            {tokens.map((token: TokenStore) => {
              return (
                <div
                  key={token.address.toViemAddress()}
                  onClick={() => handleTokenSelect(token)}
                  className={cn(
                    "flex cursor-pointer items-center justify-start gap-2",
                    "rounded-xl px-4 py-2 hover:bg-p300",
                  )}
                >
                  <TokenIcon token={token} className="shrink" size={24} />
                  <div className="text-sm text-t100">{token.symbol}</div>
                </div>
              )
            })}
          </div>
        </div>
      </ShowWhenTrue>
    </>
  )
}
